import InvoicePreviewPDF from "@components/PreviewPdfModal/InvoicePreviewPDF";
import { useCreateInvoiceHook } from "@hooks/CreateInvoiceHook/useCreateInvoiceHook";
import { PDFViewer } from "@react-pdf/renderer";
import React from "react";
import Modal from "react-modal";
import { useGetBankByIdQuery } from "store/bank/bank.api";

const PreviewPdfModal = ({
  showPreview,
  setShowPreview,
  previewInvoiceData,
  isAvoir,
  title,
  isQuote,
  previewPdf,
}) => {
  console.log("🚀 ~ previewInvoiceData:", previewInvoiceData);
  const { paymentInfo } = useCreateInvoiceHook();
  const {
    data: bankData,
    isLoading: isBankLoading,
    isError: isBankError,
    refetch,
  } = useGetBankByIdQuery(previewInvoiceData?.idbank, {
    skip: !previewInvoiceData?.idbank,
  });
  console.log("🚀 ~ bankData:", bankData);
  return (
    <Modal
      isOpen={showPreview}
      onRequestClose={() => setShowPreview(false)}
      contentLabel="Prévisualisation de la facture"
      style={{
        content: {
          width: "80vw",
          height: "90vh",
          margin: "auto",
          zIndex: 2000, // <-- Add your desired z-index here
        },
        overlay: {
          zIndex: 1999, // <-- Optionally set overlay z-index too
        },
      }}>
      <button
        onClick={() => setShowPreview(false)}
        style={{
          width: "100%",
          background: "none",
          border: "1px solid #ccc",
          padding: "8px 12px",
          textAlign: "right",
          cursor: "pointer",
          // float:"right"
        }}>
        Fermer
      </button>
      <PDFViewer style={{ width: "100%", height: "calc(90vh - 50px)" }}>
        {previewPdf ? (
          previewPdf
        ) : (
          <InvoicePreviewPDF
            invoiceData={previewInvoiceData}
            isAvoir={isAvoir}
            title={title}
            paymentInfo={bankData?.data}
            isQuote={isQuote}
          />
        )}
      </PDFViewer>
    </Modal>
  );
};

export default PreviewPdfModal;
